const STORAGE_KEY = 'lexicontest_session';
const SESSION_TTL_MS = 3_600_000; // 1 hour

export interface GameSession {
  game_id: string;
  player_id: string;
}

interface StoredSession extends GameSession {
  saved_at: number;
}

export function useGameSession() {
  function save(session: GameSession): void {
    try {
      const stored: StoredSession = { ...session, saved_at: Date.now() };
      localStorage.setItem(STORAGE_KEY, JSON.stringify(stored));
    } catch (e) {
      console.warn('[useGameSession] Failed to save session:', e);
    }
  }

  function load(): GameSession | null {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) return null;
      const parsed = JSON.parse(raw);
      if (
        typeof parsed.game_id === 'string' &&
        parsed.game_id.trim().length > 0 &&
        typeof parsed.player_id === 'string' &&
        parsed.player_id.trim().length > 0
      ) {
        // Reject stale sessions older than TTL
        if (typeof parsed.saved_at === 'number' && Date.now() - parsed.saved_at > SESSION_TTL_MS) {
          clear();
          return null;
        }
        return {
          game_id: parsed.game_id,
          player_id: parsed.player_id,
        };
      }
      return null;
    } catch {
      return null;
    }
  }

  function clear(): void {
    try {
      localStorage.removeItem(STORAGE_KEY);
    } catch (e) {
      console.warn('[useGameSession] Failed to clear session:', e);
    }
  }

  return { save, load, clear };
}
